import { cx } from 'class-variance-authority';
import { round } from 'lodash';
import { HTMLProps } from 'react';

interface Props extends Pick<HTMLProps<HTMLDivElement>, 'children'> {
    radius?: number;
    stroke?: number;
    progress?: number;
    color?: 'success' | 'danger' | 'warning';
    spin?: boolean;
    withoutText?: boolean;
}

export const CircularProgress = ({
    radius = 80,
    stroke = 8,
    withoutText,
    progress: _progress,
    spin,
    color = 'success',
    children
}: Props) => {
    const progress = spin ? 20 : round(_progress);
    const normalizedRadius = radius - stroke * 2;
    const circumference = normalizedRadius * 2 * Math.PI;
    const strokeDashoffset = circumference - (progress / 100) * circumference;

    return (
        <div
            className="tw-relative"
            style={{
                width: radius * 2,
                height: radius * 2
            }}
        >
            <div className="tw-absolute tw-left-1/2 tw-top-1/2 -tw-translate-x-1/2 -tw-translate-y-1/2">
                {children ||
                    (!withoutText && <span className="tw-text-lg tw-font-bold">{spin ? '' : `${progress} %`}</span>)}
            </div>
            <svg height={radius * 2} width={radius * 2} className={cx(spin && 'tw-animate-spin', 'tw-transition-all')}>
                <circle
                    className="tw-stroke-gray-200 tw-text-gray-400"
                    strokeWidth={stroke}
                    fill="transparent"
                    r={normalizedRadius}
                    cx={radius}
                    cy={radius}
                />
                <circle
                    className={cx(
                        color === 'success' && 'tw-stroke-success',
                        color === 'danger' && 'tw-stroke-red-500',
                        color === 'warning' && 'tw-stroke-yellow-500',
                        'tw-transition-[stroke-dashoffset]'
                    )}
                    fill="transparent"
                    strokeWidth={stroke}
                    strokeDasharray={circumference + ' ' + circumference}
                    style={{ strokeDashoffset, strokeLinecap: 'round' }}
                    r={normalizedRadius}
                    cx={radius}
                    cy={radius}
                />
            </svg>
        </div>
    );
};

export default CircularProgress;
